module.exports = __webpack_public_path__ + "media/reskin-images/icon--pause-circle-33053fed.svg";